import React, { Fragment, useEffect, useState, useContext } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import { Btn, H3, P, Image } from "../../../AbstractElements";
import { useForm } from 'react-hook-form';
import { Row, Col, Container, Card, CardHeader, CardBody, CardFooter, Form, FormGroup, Label, Input, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import { ApiRequest, ToastBuilder } from '../../../GlobalComponents/Builders';
import { showRelativeTime } from '../../../GlobalComponents/Helpers';
import { AccountContext } from '../../../GlobalComponents/Authentication/Accounts';

document.title = 'View User'

const User = () => {

    let { userId } = useParams();
    const navigate = useNavigate();
    const { isGlobal } = useContext(AccountContext);

    const [data, setData] = useState(null);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [actionProcessing, setActionProcessing] = useState(false);

    const { register, handleSubmit, reset, formState: { errors } } = useForm();

    const getUserData = () => {
        ApiRequest('GET', '/users/{userId}', { pathParams: { userId } }).then(function (res) {
            const user = Array.isArray(res.data) ? res.data[0] : res.data;
            if (!user) {
                ToastBuilder('error', 'User not found');
                return;
            }
            setData(user);
            reset({
                first_name: user.first_name ?? '',
                last_name: user.last_name ?? '',
                email: user.email ?? '',
                is_primary_technical_contact: user.is_primary_technical_contact === 1 || user.is_primary_technical_contact === '1',
                end_client_name: user.end_client_name ?? '',
            });
        });
    };

    useEffect(() => {
        getUserData();
    }, []);

    const onProfileEdit = (formValues) => {
        const body = {
            first_name: formValues.first_name,
            last_name: formValues.last_name,
            email: formValues.email,
            is_primary_technical_contact: formValues.is_primary_technical_contact ? 1 : 0,
            end_client_name: formValues.end_client_name,
        };

        ApiRequest('PATCH', '/users/{userId}', {
            pathParams: { userId },
            body,
            toastOnSuccess: 'User updated',
            toastOnError: true,
        }).then(function (res) {
            if (res.success) getUserData();
        });
    };

    const runUserAction = (actionName, successMessage) => {
        ApiRequest('POST', '/users/{userId}/actions/{actionName}', {
            pathParams: { userId, actionName },
            setIsProcessing: setActionProcessing,
        }).then(function (res) {
            if (res.success) {
                ToastBuilder('success', res.data?.message || successMessage);
            } else {
                ToastBuilder('error', res.error || res.data?.message || 'Request failed');
            }
        });
    };

    const onDeleteUser = () => {
        ApiRequest('DELETE', '/users/{userId}', {
            pathParams: { userId },
            setIsProcessing: setActionProcessing,
        }).then(function (res) {
            setDeleteModalOpen(false);
            if (res.success) {
                ToastBuilder('success', res.data?.message || 'User deleted');
                navigate(`${process.env.PUBLIC_URL}/users`);
            } else {
                ToastBuilder('error', res.error || res.data?.message || 'Failed to delete user');
            }
        });
    };

    const renderReadOnly = (value) => (value ? showRelativeTime(value) : '-');

    return (
        <Fragment>
            <Container fluid={true}>
                {data ?
                    <div className="edit-profile">
                        <Row>
                            <Col xl="6">
                                <Form onSubmit={handleSubmit(onProfileEdit)}>
                                    <Card>
                                        <CardHeader className='pb-0'>
                                            <Row className="mb-2">
                                                <div className="profile-title">
                                                    <div className="media">
                                                        <Image attrImage={{ className: 'img-70 rounded-circle', alt: '', src: `${require('../../../assets/images/user/7.jpg')}` }} />
                                                        <div className="media-body">
                                                            <H3 attrH3={{ className: 'mb-1 f-20 txt-primary' }}>{(data.first_name || '') + ' ' + (data.last_name || '')}</H3>
                                                            <P>USER</P>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Row>
                                        </CardHeader>
                                        <CardBody>
                                            <Row>
                                                <Col md="12">
                                                    <FormGroup>
                                                        <Label className="form-label">First Name</Label>
                                                        <Input
                                                            className="form-control"
                                                            type="text"
                                                            placeholder="First Name"
                                                            {...register('first_name')}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                <Col md="12">
                                                    <FormGroup>
                                                        <Label className="form-label">Last Name</Label>
                                                        <Input
                                                            className="form-control"
                                                            type="text"
                                                            placeholder="Last Name"
                                                            {...register('last_name')}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                <Col md="12">
                                                    <FormGroup>
                                                        <Label className="form-label">Email Address</Label>
                                                        <Input
                                                            className="form-control"
                                                            type="email"
                                                            placeholder="client@email.com"
                                                            {...register('email', {
                                                                pattern: {
                                                                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                                                    message: 'Please enter a valid email address',
                                                                },
                                                            })}
                                                        />
                                                        {errors.email ? <span className="text-danger" style={{ fontSize: 12 }}>{errors.email.message}</span> : null}
                                                    </FormGroup>
                                                </Col>
                                                <Col md="12">
                                                    <FormGroup>
                                                        <Label className="form-label">End Client Name</Label>
                                                        <Input
                                                            className="form-control"
                                                            type="text"
                                                            placeholder="End Client Name"
                                                            {...register('end_client_name')}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                <Col md="12">
                                                    <FormGroup check className="mb-2">
                                                        <Label check>
                                                            <Input type="checkbox" {...register('is_primary_technical_contact')} />
                                                            {' '}Primary Technical Contact
                                                        </Label>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </CardBody>
                                        <CardFooter className="text-end">
                                            <Btn attrBtn={{ color: "primary", type: "submit" }} >{'Update Profile'}</Btn>
                                        </CardFooter>
                                    </Card>
                                </Form>
                            </Col>
                            <Col xl="6">
                                <Card>
                                    <CardHeader className='pb-0'>
                                        <H3 attrH3={{ className: 'card-title mb-0 f-16' }}>Activity</H3>
                                    </CardHeader>
                                    <CardBody>
                                        <Row className="mb-2">
                                            <Col sm="4"><Label className="form-label mb-0">Created</Label></Col>
                                            <Col sm="8"><P>{renderReadOnly(data.date_created)}</P></Col>
                                        </Row>
                                        <Row className="mb-2">
                                            <Col sm="4"><Label className="form-label mb-0">Last change</Label></Col>
                                            <Col sm="8"><P>{renderReadOnly(data.updated_at)}</P></Col>
                                        </Row>
                                        <Row className="mb-2">
                                            <Col sm="4"><Label className="form-label mb-0">Last login</Label></Col>
                                            <Col sm="8"><P>{renderReadOnly(data.last_login)}</P></Col>
                                        </Row>
                                    </CardBody>
                                    {isGlobal ?
                                        <CardFooter>
                                            <div className="d-flex flex-wrap gap-2">
                                                <Btn attrBtn={{ color: "secondary", type: "button", disabled: actionProcessing, onClick: () => runUserAction('reset-password', 'Password reset email sent') }}>Send Password Reset</Btn>
                                                <Btn attrBtn={{ color: "secondary", type: "button", disabled: actionProcessing, onClick: () => runUserAction('resend-welcome', 'Welcome email sent') }}>Resend Welcome Email</Btn>
                                                <Btn attrBtn={{ color: "danger", type: "button", disabled: actionProcessing, onClick: () => setDeleteModalOpen(true) }}>Delete User</Btn>
                                            </div>
                                        </CardFooter> : null}
                                </Card>
                            </Col>
                        </Row>
                    </div> : null}
            </Container>

            <Modal isOpen={deleteModalOpen} toggle={() => setDeleteModalOpen(!deleteModalOpen)} centered>
                <ModalHeader toggle={() => setDeleteModalOpen(!deleteModalOpen)}>Delete User</ModalHeader>
                <ModalBody>
                    Are you sure you want to delete {(data?.first_name || '') + ' ' + (data?.last_name || '')}? This deactivates the account and disables their sign-in.
                </ModalBody>
                <ModalFooter>
                    <Btn attrBtn={{ color: "light", type: "button", onClick: () => setDeleteModalOpen(false) }}>Cancel</Btn>
                    <Btn attrBtn={{ color: "danger", type: "button", disabled: actionProcessing, onClick: onDeleteUser }}>Delete</Btn>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
};
export default User;
